export default __webpack_public_path__ + "static/media/logo-form.b570506a.png";